import { render, staticRenderFns } from "./HeaderTransferToAccount.vue?vue&type=template&id=3b9e8078"
import script from "./HeaderTransferToAccount.vue?vue&type=script&lang=js"
export * from "./HeaderTransferToAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports